import { getMicroserviceBaseContext } from '../../constants/api-routing';

const secretsContext = getMicroserviceBaseContext('secrets');

export const SECRETS_SERVICE = {
    getKeyVault: `${secretsContext}secrets`,
}
